import { useCallback } from "react";
import { Modal } from "antd";
import OrderDTO from "@/dto/order/OrderDTO";
import OrderItemLabelPrinter from "@/services/print/orderlabel/OrderItemLabelCloudPrinter";
import { useModalStore } from "@/hooks/Modal/hooks";
import PrintOrderItemLabelModal from "../../../dialogs/PrintOrderItemLabelDialog/PrintOrderItemLabelModal";

export default function usePrintOrderItemLabelClick(
    getSelectedOrders: () => OrderDTO[],
    printSuccessCallback?: () => void,
) {
    const modalStore = useModalStore();

    const handlePrintOrderItemLabel = useCallback(() => {
        if (!OrderItemLabelPrinter.isReady()) {
            OrderItemLabelPrinter.openDownloadPluginDialog();
            return;
        }

        const selectedOrders = getSelectedOrders();

        if (!selectedOrders?.length) {
            return;
        }

        const isSomeOrderItemLabelPrinted = selectedOrders.some((order) => order.isOrderItemLabelPrinted);

        if (isSomeOrderItemLabelPrinted) {
            Modal.confirm({
                title: "所选订单中部分订单已打印商品标签，是否继续打印？",
                onOk() {
                    modalStore.openModal(PrintOrderItemLabelModal, {
                        orders: selectedOrders,
                        onSuccess: printSuccessCallback,
                    });
                },
                focusable: { autoFocusButton: "ok" },
            });
        } else if (selectedOrders.length !== 0) {
            modalStore.openModal(PrintOrderItemLabelModal, {
                orders: selectedOrders,
                onSuccess: printSuccessCallback,
            });
        }
    }, [getSelectedOrders]);

    return {
        handlePrintOrderItemLabel,
    };
}
